import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import './pages.css';

export function NotFoundPage() {
  return (
    <div className="page">
      <Card title="Page not found">
        <p>The page you are looking for does not exist.</p>
        <p>
          <Link to="/portal">Back to Overview</Link>
        </p>
      </Card>
    </div>
  );
}
